/* ==================================================================================
   SECTION: What's Inside
   Vanilla JS, no dependencies. Handles:
     - single-open accordion behavior for ingredient/material panels
     - smooth height animation (measured, not guessed)
     - keyboard support (Enter / Space activate; native button semantics
       already provide Tab focus order)
     - the "Show / Hide Full Ingredients" slide toggle
   Runs once per section instance; re-initializes correctly inside the
   Theme Editor when a section is re-rendered.
================================================================================== */

(function () {
  'use strict';

  function initWhatsInside(root) {
    if (!root || root.dataset.wiInitialized === 'true') return;
    root.dataset.wiInitialized = 'true';

    var panels = Array.prototype.slice.call(root.querySelectorAll('.whats-inside__panel'));

    function setPanelState(panel, isOpen) {
      var trigger = panel.querySelector('.whats-inside__trigger');
      var body = panel.querySelector('.whats-inside__panel-body');
      if (!trigger || !body) return;

      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.classList.toggle('is-active', isOpen);

      if (isOpen) {
        body.hidden = false;
        // Force reflow so the browser registers the starting height before animating.
        // eslint-disable-next-line no-unused-expressions
        body.offsetHeight;
        body.style.maxHeight = body.scrollHeight + 'px';
      } else {
        body.style.maxHeight = body.scrollHeight + 'px';
        // eslint-disable-next-line no-unused-expressions
        body.offsetHeight;
        body.style.maxHeight = '0px';
      }
    }

    function openPanel(targetPanel) {
      panels.forEach(function (panel) {
        var shouldOpen = panel === targetPanel;
        var isCurrentlyOpen = panel.classList.contains('is-active');
        if (shouldOpen === isCurrentlyOpen) return;
        setPanelState(panel, shouldOpen);
      });
    }

    panels.forEach(function (panel) {
      var trigger = panel.querySelector('.whats-inside__trigger');
      var body = panel.querySelector('.whats-inside__panel-body');
      if (!trigger || !body) return;

      // Clear inline max-height after an "open" transition finishes so the
      // panel can respond correctly to window resizes (e.g. text reflow).
      body.addEventListener('transitionend', function (event) {
        if (event.propertyName !== 'max-height') return;
        if (panel.classList.contains('is-active')) {
          body.style.maxHeight = 'none';
        } else {
          body.hidden = true;
        }
      });

      trigger.addEventListener('click', function () {
        var isOpen = panel.classList.contains('is-active');
        if (isOpen) {
          // Allow closing the single open panel entirely (all panels collapsed).
          setPanelState(panel, false);
        } else {
          openPanel(panel);
        }
      });
    });

    // Initialize the default-open panel's height (server-rendered as open).
    var initiallyActive = root.querySelector('.whats-inside__panel.is-active .whats-inside__panel-body');
    if (initiallyActive) {
      initiallyActive.style.maxHeight = 'none';
    }

    // ---------------- Full ingredients list toggle ----------------
    var listToggle = root.querySelector('.whats-inside__full-list-toggle');
    var listBody = root.querySelector('.whats-inside__full-list-body');

    if (listToggle && listBody) {
      listToggle.addEventListener('click', function () {
        var isOpen = listToggle.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          listBody.style.maxHeight = listBody.scrollHeight + 'px';
          // eslint-disable-next-line no-unused-expressions
          listBody.offsetHeight;
          listBody.style.maxHeight = '0px';
          listBody.dataset.open = 'false';
          listToggle.setAttribute('aria-expanded', 'false');
        } else {
          listBody.hidden = false;
          // eslint-disable-next-line no-unused-expressions
          listBody.offsetHeight;
          listBody.style.maxHeight = listBody.scrollHeight + 'px';
          listBody.dataset.open = 'true';
          listToggle.setAttribute('aria-expanded', 'true');
        }
      });

      listBody.addEventListener('transitionend', function (event) {
        if (event.propertyName !== 'max-height') return;
        if (listBody.dataset.open === 'true') {
          listBody.style.maxHeight = 'none';
        } else {
          listBody.hidden = true;
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="whats-inside"]').forEach(initWhatsInside);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify's Theme Editor re-renders this section.
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target.querySelector
      ? event.target.querySelector('[data-section-type="whats-inside"]')
      : null;
    if (target) initWhatsInside(target);
  });
})();